import { buildFacetDesignOverride } from 'Packages/FacetRest/FacetDesignOverride';

export const IncomeInformationOverride = buildFacetDesignOverride();
